import React from 'react'
import './App.scss'
import JobItem from './components/JobItem/jobItem'
import CompanyItem from './components/CompanyItem/companyItem'
import http_zcm from './env/http_zcm'
import fetchJsonp from 'fetch-jsonp'
import { spareaIdStr, DataFn } from './data'

function idStr(arr) {
  let idArr = []
  arr.forEach((item) => {
    idArr.push(parseInt(item.mUrl.substring(42)))
  })
  return idArr.toString()
}
export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      qyList: [],
      pageIndex: 0,
      jobSpecialData: [],
      specialData: [],
      totalPage: 0,
      entNum: [], //全部专场的企业规模
      entList: [], //企业列表
    }
    this.clickMore = this.clickMore.bind(this)
    this.createActivity = this.createActivity.bind(this)
  }
  //创建活动
  createActivity() {
    let action = 'https://survey.58.com/?id=1021497&hash=sw11'
    window.location.href = action
  }

  qyRequest() {
    let baseURL = ''
    if (process.env.NODE_ENV === 'development') {
      baseURL = ''
    } else {
      baseURL = '//zcmoperation.58.com'
    }
    http_zcm({
      url: baseURL + '/zcm/operation/api/h5',
      params: { cmd: 'springwind2021.famousenterprise' },
    }).then((res) => {
      if (res) {
        if (res.resultcode === 0) {
          this.setState({
            qyList: res.result.entList,
          })
        } else if (res.resultcode === 1003) {
          alert('请先登陆')
          console.log('未登陆')
        }
      }
    })
  }

  speciRequest() {
    let baseURL = ''
    if (process.env.NODE_ENV === 'development') {
      baseURL = ''
    } else {
      baseURL = '//zcmoperation.58.com'
    }
    http_zcm({
      url: baseURL + '/zcm/operation/api/h5',
      params: { cmd: 'springwind2021.spreaentnum', spareaIds: '' },
    }).then((res) => {
      if (res) {
        if (res.resultcode === 0) {
          let entList = [].concat(res.result.entNumList)
          console.log('entList', entList)
          let idstr = idStr(entList)
          let secondInfo = []
          let that = this
          fetchJsonp('//hrgserver.58.com/yytmp/getdata/app/online/' + idstr)
            .then(function (response) {
              return response.json()
            })
            .then(function (json) {
              secondInfo = json.data.onlineData
              entList.map((item, index) => {
                item['pageTitle'] = secondInfo[index].pageGlobalConfig.pageTitle
                item['startTime'] = secondInfo[index]._redisStartTime
                item['endTime'] = secondInfo[index]._redisEndTime
                item['imgUrl'] =
                  secondInfo[index].pageGlobalConfig.shareConfigInfo.imgUrl ||
                  ''
              })
              that.setState(
                {
                  entList: entList,
                  specialData: entList.slice(0, 6),
                  totalPage: Math.ceil(29 / 6),
                },
                () => {
                  console.log('specialData', that.state.specialData)
                }
              )
            })
            .catch(function (ex) {
              console.log('parsing failed', ex)
            })
        } else if (res.resultcode === 1003) {
          alert('请先登陆')
          console.log('未登陆')
        }
      }
    })
  }
  componentDidMount() {
    this.qyRequest()
    this.speciRequest()
  }

  clickMore() {
    let { pageIndex, specialData, jobSpecialData, entList } = this.state
    let page = pageIndex + 1
    let jobList = jobSpecialData[page]
    let newJobList = entList.slice(0, 6 * page)
    this.setState({
      pageIndex: page,
      specialData: newJobList,
    })
  }
  render() {
    let { pageIndex, totalPage, specialData, qyList } = this.state
    return (
      <div className="App">
        <div className="header">
          <div className="header-bg"></div>
          <div className="createActivity">
            <div
              className="createButton"
              onClick={() => {
                this.createActivity()
              }}
            >
              我要创建活动
            </div>
            <p className="discription">支持各地政府创建活动</p>
          </div>
        </div>
        <div className="jobSpecial">
          <div className="livingRecr_title">· 就业有我帮专场 ·</div>
          <div className="jobList">
            {specialData.length !== 0 &&
              specialData.map((item, index) => {
                return <JobItem key={index} item={item} />
              })}
          </div>
          <div
            className="clickMore"
            onClick={() => {
              this.clickMore()
            }}
            style={{
              display: parseInt(pageIndex) < totalPage ? 'block' : 'none',
            }}
          >
            查看更多
          </div>
        </div>
        <div className="compoanySpecial">
          <div className="livingRecr_title">· 名企专场 ·</div>
          <div className="companyList">
            {qyList.map((item, index) => {
              return <CompanyItem key={index} item={item} />
            })}
          </div>
        </div>
        <div className="highLights">
          <div className="livingRecr_title">· 活动亮点 ·</div>
          <div className="highLights_content">
            <div className="contentPart">
              <div className="title">六大项目</div>
              <div className="title">聚焦两类重点人群</div>
              <div className="text">
                面向高校毕业生开展人才测评、职业培训、线上招聘专场，面向农民工及就业困难群体开展求职课堂、技能提升课和专场招聘会，提升就业能力，岗位连接效率。
              </div>
            </div>
            <div className="contentPart">
              <div className="title">两类举措</div>
              <div className="title">扶持企业发展</div>
              <div className="text">
                开展“千万补贴招聘行动”，帮助企业复工复产，并通过各类专业服务，赋能企业人才招聘。
              </div>
            </div>
            <div className="contentPart">
              <div className="title">两大支持</div>
              <div className="title">助力国家政策落实</div>
              <div className="text">
                支持政府部门开展春风行动等各类促就业专项行动，并为国家各项就业政策制定提供就业数据服务。
              </div>
            </div>
          </div>
        </div>
        <div className="reminder">
          <div className="livingRecr_title">· 温馨提示 ·</div>
          <div className="reminderList">
            <img
              className="reminderItem"
              alt=""
              src={require('./assets/img/tishi.png')}
            ></img>
          </div>
        </div>
      </div>
    )
  }
}
